import React, { useState, useEffect } from "react";
import { Select, Input, Modal, Form, Button } from "antd";
import { noop, isEmpty } from "lodash";

const CategoryMedicalEquipmentFormModal = ({
  data = {},
  columnData,
  visible,
  submitText,
  title,
  onCancel,
  ...props
}) => {
  const [imageUrl, setImageUrl] = useState(columnData && columnData.pic_url);
  const [imageUploadUrl, setImageUploadUrl] = useState("");

  const [form] = Form.useForm();
  const { Option } = Select;

  const onOk = () => {
    form
      .validateFields()
      .then(async (values) => {
        values.pic_url = imageUploadUrl === "" ? imageUrl : imageUploadUrl;
        await props.onSubmit(values);
        onCancel();
        setImageUrl("");
        // form.resetFields();
        if (isEmpty(data)) {
          form.resetFields();
        }
      })
      .catch(noop);
  };
  const onModalCancel = () => {
    form.resetFields();
    setImageUrl("");
    onCancel();
  };
  const modalFooter = (
    <Button onClick={onOk} type="primary">
      {submitText}
    </Button>
  );

  useEffect(() => {
    form.resetFields();
    setImageUrl("");
  }, []);

  return (
    <Modal
      visible={visible}
      onCancel={onModalCancel}
      onOk={onOk}
      title={title}
      okText={submitText}
      destroyOnClose
      footer={modalFooter}
      {...props}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={columnData}
        onFinish={onOk}
      >
        <Form.Item
          label="Name"
          name="name"
          rules={[
            { required: true, message: "Please input name!" },
            { max: 25, message: "Name must be maximum 25 characters." },
          ]}
        >
          <Input size="large" placeholder="Enter Name" />
        </Form.Item>

        <Form.Item
          label="Status"
          name="status"
          rules={[{ required: true, message: "Please select Status!" }]}
        >
          <Select size="large" placeholder="Status - Active / Blocked">
            <Option value>Active</Option>
            <Option value={false}>Blocked</Option>
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
};
export default CategoryMedicalEquipmentFormModal;
